import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      isLoading: false,
      error: null,

      login: async (email, password) => {
        set({ isLoading: true, error: null });
        try {
          // Simulation d'une API de connexion
          await new Promise(resolve => setTimeout(resolve, 1000));
          
          // Mock user data
          const mockUser = {
            id: '1',
            name: 'John Doe',
            email: email,
            role: 'admin',
            company: 'SolarTech Pro',
            subscription: 'premium',
            avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face'
          };
          
          const mockToken = 'mock-jwt-token-' + Date.now();
          
          set({ 
            user: mockUser, 
            token: mockToken, 
            isLoading: false 
          });
          
          return mockUser;
        } catch (error) {
          set({ 
            error: 'Erreur de connexion', 
            isLoading: false 
          });
          throw error;
        }
      },

      register: async (userData) => {
        set({ isLoading: true, error: null });
        try {
          // Simulation d'une API d'inscription
          await new Promise(resolve => setTimeout(resolve, 1000));
          
          const mockUser = {
            id: '2',
            name: userData.name,
            email: userData.email,
            role: 'user',
            company: userData.company || 'Nouvelle entreprise',
            subscription: 'free',
            avatar: 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=150&h=150&fit=crop&crop=face'
          };
          
          const mockToken = 'mock-jwt-token-' + Date.now();
          
          set({ 
            user: mockUser, 
            token: mockToken, 
            isLoading: false 
          });
          
          return mockUser;
        } catch (error) {
          set({ 
            error: 'Erreur d\'inscription', 
            isLoading: false 
          });
          throw error;
        }
      },

      logout: async () => {
        set({ isLoading: true });
        try {
          // Simulation d'une API de déconnexion
          await new Promise(resolve => setTimeout(resolve, 500));
          
          set({ 
            user: null, 
            token: null, 
            isLoading: false,
            error: null 
          });
        } catch (error) {
          set({ 
            error: 'Erreur de déconnexion', 
            isLoading: false 
          });
          throw error;
        }
      },

      updateProfile: async (updates) => {
        set({ isLoading: true, error: null });
        try {
          await new Promise(resolve => setTimeout(resolve, 500));
          
          const currentUser = get().user;
          const updatedUser = { ...currentUser, ...updates };
          
          set({ 
            user: updatedUser, 
            isLoading: false 
          });
          
          return updatedUser;
        } catch (error) {
          set({ 
            error: 'Erreur de mise à jour', 
            isLoading: false 
          });
          throw error;
        }
      },

      clearError: () => set({ error: null }),
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({ 
        user: state.user, 
        token: state.token 
      }),
    }
  )
);

export const useAuth = () => {
  const store = useAuthStore();
  
  return {
    user: store.user,
    token: store.token,
    isLoading: store.isLoading,
    error: store.error,
    login: store.login,
    register: store.register,
    logout: store.logout,
    updateProfile: store.updateProfile,
    clearError: store.clearError,
    isAuthenticated: !!store.user && !!store.token,
  };
}; 